const argentinianDocumentValidator = doc => {
  const verifyCuit = doc => {
    if (doc.length !== 11) {
      return false
    }

    let accumulated = 0
    let digits = doc.split('')
    let checkDigit = parseInt(digits.pop())

    for (let i = 0; i < digits.length; i++) {
      accumulated += digits[9 - i] * (2 + (i % 6))
    }

    let verification = 11 - (accumulated % 11)
    if (verification === 11) {
      verification = 0
    } else if (verification === 10) {
      verification = 9
    }

    return checkDigit === verification
  }

  if (verifyCuit(doc)) {
    return doc.slice(0, 2) > 29 ? 'CUIT' : 'CUIL'
  }

  return false
}

const uruguayanDocumentValidator = doc => {
  const checkRut = doc => {
    if (doc.length !== 12 || isNaN(doc)) {
      return false
    }

    const dc = doc.slice(-1)
    const rutDigits = doc.slice(0, -1)
    let total = 0
    let factor = 2

    for (let i = rutDigits.length - 1; i >= 0; i--) {
      total += factor * parseInt(rutDigits[i])
      factor = factor === 9 ? 2 : factor + 1
    }

    let dv = 11 - (total % 11)

    if (dv === 11) {
      dv = 0
    } else if (dv === 10) {
      dv = 1
    }

    return dv === parseInt(dc)
  }

  const checkCi = doc => {
    doc = doc.replace(/\D/g, '')
    const dig = doc.slice(-1)
    doc = doc.slice(0, -1)

    if (doc.length < 7) {
      doc = doc.padStart(7, '0')
    }

    let a = 0
    for (let i = 0; i < 7; i++) {
      a += (parseInt('2987634'[i]) * parseInt(doc[i])) % 10
    }

    const calculatedDigit = a % 10 === 0 ? 0 : 10 - (a % 10)
    return parseInt(dig) === calculatedDigit
  }

  if (checkCi(doc)) return 'CI'
  else if (checkRut(doc)) return 'RUT'
  else return false
}

export { argentinianDocumentValidator, uruguayanDocumentValidator }
